import script from "./EnvironmentManager.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvironmentManager.vue?vue&type=script&setup=true&lang=js"

import "./EnvironmentManager.vue?vue&type=style&index=0&id=3f696996&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f696996"]])

export default __exports__